<template>
  <div class="display-back-arrow-wrapper">
    <van-nav-bar class="nav-bar" left-arrow :title="title" @click-left="handleBack" />
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    path: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleBack() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.display-back-arrow-wrapper {
  height: 46px;
  .nav-bar {
    width: 100%;
    position: fixed;
  }
}
</style>
